import { FC } from "react";

import { UseFormReturn } from "react-hook-form";

import { NewsletterFormSignupData } from "../types";

import { isEmailAndAllowPlus, isRequired } from "@/common/helpers/validators";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardEmailTextField } from "@/dashboard-design-system/EmailTextField";

type NewsletterFormEmailFieldProps = {
  form: UseFormReturn<NewsletterFormSignupData>;
  previewConfiguration?: {
    isPreview: boolean;
  };
};

export const NewsletterFormEmailField: FC<NewsletterFormEmailFieldProps> = ({ form }) => {
  const { t } = useTranslate();
  const { errors } = form.formState;

  return (
    <DashboardEmailTextField
      name="email"
      data-test="form-email"
      control={form.control}
      placeholder={t("dashboard", "newsletterForms.editor.step.questions.field.email")}
      rules={[
        isRequired(t("common", "emailAddress.required")),
        isEmailAndAllowPlus(t("common", "emailFormat"), t("common", "emailFormat.wrongChar")),
      ]}
      errorMessage={errors.email?.message}
      disableAutocomplete
    />
  );
};
